module.exports = __webpack_public_path__ + "img/sarre-mini.0e142650.gif";